import { render, staticRenderFns } from "./FeedbackSummary.vue?vue&type=template&id=da28b2a8&"
import script from "./FeedbackSummary.vue?vue&type=script&lang=js&"
export * from "./FeedbackSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports